import React from 'react';
import {
    Button,
    Modal,
    ModalBody,
    ModalCloseButton, ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text
} from "@chakra-ui/react";


const DialogChoose = (props) => {

    return (
        <>
            <Modal
                isOpen={props?.isOpen || false}
                onClose={() => {
                    if (props?.onClose) {
                        props?.onClose();
                    }
                }}>
                <ModalOverlay/>
                <ModalContent>
                    <ModalHeader>{props?.title || "Avviso"}</ModalHeader>
                    <ModalCloseButton/>
                    <ModalBody>
                        <Text>{props?.message || "Sei sicuro di questa operazione?"}</Text>
                    </ModalBody>

                    <ModalFooter>
                        <Button
                            colorScheme='blue' mr={3}
                            onClick={()=>{
                                if(props?.onDismiss){
                                    props?.onDismiss()
                                }
                                if (props?.onClose) {
                                    props?.onClose();
                                }
                            }}>
                            {props?.dismissText || "ANNULLA"}
                        </Button>
                        <Button
                            onClick = {()=>{
                                if(props?.onAccept){
                                    props?.onAccept()
                                }
                                if (props?.onClose) {
                                    props?.onClose();
                                }
                            }}
                            colorScheme='blue'
                            mr={3}>
                            {props?.acceptText || "ACCETTA"}
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    );
};

export default DialogChoose;